<form *ngIf="loginReady" class="form-signin">
  <mat-card>
    <div class="text-center">
      <h1>Sign In</h1>
    </div>
    <mat-form-field appearance="outline">
      <mat-icon matPrefix>person</mat-icon>
      <mat-label>Username</mat-label>
      <input matInput placeholder="" [(ngModel)]="model.username" required [ngModelOptions]="{standalone: true}">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-icon matPrefix>lock</mat-icon>
      <mat-label>Password</mat-label>
      <input type="password" matInput placeholder="" [(ngModel)]="model.password" required [ngModelOptions]="{standalone: true}">
    </mat-form-field>
    <div style="width:100%; margin-bottom:20px" *ngIf="showLoading">
      <div style="display: block; margin-left: auto; margin-right: auto; width: 40px;">
        <mat-spinner mode="indeterminate" diameter="40" ></mat-spinner>
      </div>
    </div>
    <button *ngIf="!showLoading" class="btn-login btn btn-success" (click)="signIn()">Sign In</button>
  </mat-card>
</form>